export default "__VITE_ASSET__pq0Yx2_1__"